export class MobileScreenSizeDetector {
  isMobileScreenSize(): boolean {
    return window.innerWidth < 768;
  }
}
